/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
      updatePVTracker(cart);
    }
  });
  // Fired when page loads to update header values
  // document.addEventListener("theme:cart:init", (e) => {
  //   console.log("theme:cart:init");
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener("theme:scroll", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:up", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:down", (e) => {
  //   console.log(e);
  // });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener("theme:resize", (e) => {
  //   console.log(e);
  // });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  window.customCheckout = () => {
    let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
    if (!sessionId) {
      sessionId = Date.now();
      sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
    }

    const context = {
      curSite: localStorage.getItem("CURRENT_PARTNER_STORAGE_KEY") ?? null,
      customerId: window?.customer?.id,
      customerEmail: window?.customer?.email,
      isPartner: window?.customer?.isPartner,
      taxExempt: window.customer
        ? window.customer.taxExempt === "true"
        : false,
      userType: window.customer ? window.customer.userType : null,
      sharedCoupon: sessionStorage.getItem('COUPON_CODE') ?? null,
      houseId: sessionStorage.getItem('PAID_AFFILIATION_ID') ?? null,
      distributorId: window.customer
            ? window.customer.distributorId
            : null,
    };

    console.log("context", context);

    // Build URL parameters using URLSearchParams for proper encoding
    const params = new URLSearchParams();
    params.append("attributes[sessionID]", sessionId);
    params.append("attributes[context]", btoa(JSON.stringify(context)));

    // Construct final URL
    const checkoutURL = `https://prod-shopify.senegence.com/checkout?${params.toString()}`;
    console.log("Redirecting to checkout:", checkoutURL);

    // Redirect
    window.location.href = checkoutURL;
  }

  async function configureCustomCheckout(cart) {
    console.log("configureCustomCheckout", cart);

    const customCheckout = $("[name='checkout']");

    customCheckout.unbind("click").bind("click", async (e) => {
      e.stopPropagation();
      e.preventDefault();

      console.log("customCheckout clicked");

      window.customCheckout();
    });
  }

  async function updatePVTracker(cart) {
    try {
      let pvHistory = {};
      if (window?.customer?.pvHistory) {
        pvHistory = window.customer.pvHistory;
      }

      const currentMonth = new Date().toISOString().slice(0, 7);
      const currentMonthPV = pvHistory[currentMonth] || 0;

      const cartPV = cart.items.reduce((acc, item) => {
        if (item?.properties?.["_pv"]) {
          return acc + Number(item.properties["_pv"]) * item.quantity;
        }
        return acc;
      }, 0);

      const totalPV = currentMonthPV + cartPV;

      const maxPV = 750;
      const tiers = [
        { threshold: 750, discount: 50 },
        { threshold: 300, discount: 40 },
        { threshold: 100, discount: 30 },
        { threshold: 0, discount: 20 },
      ];

      const currentTier = tiers.find((tier) => totalPV >= tier.threshold);
      const nextTier = tiers[tiers.indexOf(currentTier) - 1];

      $("[data-pv-bar]").css(
        "width",
        `${Math.min((totalPV / maxPV) * 100, 100)}%`
      );
      $("[data-pv-cart]").text(`${cartPV.toFixed(1)} PV`);
      $("[data-pv-total]").text(`${totalPV.toFixed(1)} PV`);
      $("[data-pv-tier]").text(
        `Current Discount Tier: ${currentTier.discount}%`
      );

      if (nextTier) {
        $("[data-pv-next-tier]").text(`(${nextTier.discount}%)`);
        $("[data-pv-next-tier-pv]").text(`${(nextTier.threshold - totalPV).toFixed(1)} PV`);
      }

      if (totalPV >= maxPV) {
        $(".pv-tracker__message").text(
          "🎉 You've reached the highest discount tier!"
        );
      }
    } catch (e) {
      console.log("error", e);
    }
  }

  async function initConfigureCustomCheckout() {
    const cart = await fetch("/cart.js")
      .then((res) => res.json())
      .catch((e) => console.log(e));
    configureCustomCheckout(cart);
  }

  document.addEventListener("DOMContentLoaded", initConfigureCustomCheckout);
  document.addEventListener("storage", (e) => {
    console.log("storage", e);
    if (e.key === "COUPON_CODE") {
      console.log("COUPON_CODE", e.newValue);
      initConfigureCustomCheckout();
    }
  });
})();
